var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideHelpOrng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.2917V16.3012M11.5 12.9377C11.4824 12.6266 11.5663 12.3181 11.7391 12.0589C11.912 11.7996 12.1644 11.6035 12.4583 11.5002C12.8185 11.3624 13.1419 11.1429 13.4028 10.859C13.6638 10.5751 13.8553 10.2344 13.9623 9.86389C14.0692 9.49337 14.0887 9.10307 14.0192 8.72374C13.9497 8.3444 13.7931 7.98638 13.5617 7.67786C13.3303 7.36934 13.0304 7.11874 12.6857 6.94579C12.341 6.77285 11.9609 6.68227 11.5753 6.6812C11.1896 6.68013 10.809 6.7686 10.4633 6.93963C10.1177 7.11066 9.81643 7.35959 9.58333 7.66682M20.125 11.5C20.125 16.2635 16.2635 20.125 11.5 20.125C6.73654 20.125 2.875 16.2635 2.875 11.5C2.875 6.73654 6.73654 2.875 11.5 2.875C16.2635 2.875 20.125 6.73654 20.125 11.5Z",
    stroke: "#F58634",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideHelpOrng);
export default __webpack_public_path__ + "static/media/sideHelpOrng.9234479a033724f38baf703cfb3c283e.svg";
export { ForwardRef as ReactComponent };